import { Box } from '@zillow/constellation-10';
import { Bone } from '@zg-rentals/satellite-components';
import SkeletonContainer from '../SkeletonContainer';

export default function Skeleton() {
  return (
    <Box css={{ flex: 1, paddingLeft: 'loose' }}>
      <SkeletonContainer>
        <>
          <Bone type="line" css={{ width: '33.33%', marginBottom: 'tight' }} />
          <Bone type="line" css={{ width: '66.67%', marginBottom: 'tight' }} />
        </>
      </SkeletonContainer>
    </Box>
  );
}
